<template>
  <resize-table
    :columns="columns"
    bordered
    :scroll="{ x:0, y: 450 }"
    :data-source="list"
    row-key="rawId"
    :pagination="false"
    :rowClassName="rowClassName"
  >
    <template slot="rawName" slot-scope="text,record">
      {{overseasFlag == '1' ? (record.aliasName || text) : text}}
    </template>
    <span slot="uasge" slot-scope="text">{{text == null ? text : text.toFixed(3)}}</span>
  </resize-table>
</template>

<script>
export default {
  props: ['list'],
  data(){
    return {
      columns:[
        { 
          dataIndex:'factoryName',
          title: '工厂',
          width: 120
        },
        {
          dataIndex:'animalTypeName',
          align:'center',
          title: '动物类型',
          width: 120
        },
         {
          dataIndex:'formulaName',
          title: '配方',
          width: 120
        },
        {
          dataIndex:'typeName',
          title: '原料类型',
          width: 120
        },
        {
          dataIndex:'rawName',
          title: '原料名称',
          width: 120,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          dataIndex:'uasge',
          title: '用量（吨）',
          width: 120,
          align:'center',
          scopedSlots: {customRender: 'uasge'},
        },
      ],
      overseasFlag: window.localStorage.getItem('overseasFlag'),
    }
  },
  methods: {
    rowClassName(record){
      let {isDeleted,isRawDelete,isExtraProRaw} = record || {}
      return  isRawDelete == 1 || (isExtraProRaw == 1 && isDeleted == 1) ? 'selectGary' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .selectRows{
    background-color: rgba(255, 206, 163, 0.1) !important;
    background-color:#fff9e5 !important;
  }
  ::v-deep .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
</style>